import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WhatsIncluded = ({ items }) => {
  return (
    <div className="bg-accent px-4 py-6 sm:p-8">
      <section className="py-6 px-4 sm:px-6 bg-light rounded-2xl shadow-md max-w-full sm:max-w-3xl mx-auto">
        <h2 className="text-xl sm:text-2xl font-bold text-secondary text-center mb-4">
          What’s Included?
        </h2>
        <ul className="space-y-3">
          {items.map((item, index) => (
            <li
              key={index}
              className="flex items-center space-x-3 p-4 bg-white rounded-lg shadow-sm hover:bg-accent transition"
            >
              <FontAwesomeIcon icon={item.icon} className="text-primary text-lg sm:text-xl" />
              <span className="text-sm sm:text-base font-medium text-gray-700">{item.text}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default WhatsIncluded;
